<template>
	<div class="main-contents">
		<div class="contents">
			<div class="contents_body">
				<div class="tit">
					<span>비밀번호 찾기</span><br/>
					아이디를 조회해 주세요.
				</div>
			</div>
		</div>
		<div class="mem_container">
			<div class="main-box">				
				<div class="mem_contents_body">
					<div class="info-box">
						<div class="contents-body-box">
							<p class="mb-10">아이디 입력하기</p>
							<div class="mem-id-input mb-10">
								<input type="text" name id="txt_id" placeholder="아이디 입력" v-model="mberId">
							</div>
							<div class="confirm-btn" @click="chkId()">
								아이디 조회
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { findPwMeta } from '@/utils/meta';
export default {
	metaInfo : findPwMeta,
	data() {
		return {
			mberId : ''
		}
	},

	methods : {
		chkId() {
			if(!this.mberId) {
				alert('아이디를 입력하세요.');
				return false;
			}

			this.$.httpPost('/api/mem/mberIdChk', {mberId : this.mberId}, '')
				.then(res => {
					//console.log('RESULT :', res);

					if(res.data.resultCode == '000') {
						if(res.data.idChkYn == 'Y') {
							this.$router.push({name:'MEM002M05', params:{mberId : this.mberId}});
						}else {
							alert('아이디가 존재하지 않습니다.');
						}
					}
				})
		}
	}
}
</script>